import { applyRuntimeEnv } from './runtime-env';

// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
// import env from './.env';

export const environment = {
  production: true,
  // serverUrl: 'https://ec2.gastroguide.de/', // Testsystem
  // serverUrl: 'https://api.gastroguide.de/',
  // mainServerUrl: 'https://api.gastroguide.de/',
  // secondaryServerUrl: 'https://api2.gastroguide.de/',
  serverUrl: 'https://legacy.services.gastro.digital/',
  mainServerUrl: 'https://legacy.services.gastro.digital/',
  secondaryServerUrl: 'https://legacy.services.gastro.digital/',

  ticketServerUrl: 'https://tickets.gastroguide.de',
  // defaultLanguage: 'de-DE',
  defaultLanguage: 'de',
  supportedLanguages: ['de-DE', 'de-Formal', 'en', 'de', 'es', 'nl', 'fr', 'it'],
  gastroPayUrl: 'https://gastropay.azurewebsites.de/api/v1.0/',
  revolutPayUrl: 'https://ms.gastroguide.de/',
  versionCheckURL: '/dist/version.json',
  frontendUrl: 'https://customers.gastro.digital',
  onlineResURL: 'https://reservierung.gastroguide.de',
  googleTranslationUrl: 'https://translation.googleapis.com/language/translate/v2?key=',
  googleTranslationApiKey: 'AIzaSyBeGiN_RCc2XnHI8cGtjZl_nG2tvV26juc',
  baseUrl: 'https://kunden.gastro.digital/',
  feedbackBaseUrl: 'https://feedback.gastro.digital/',
  whatAppBotUrl: 'https://wa.gastro.digital/',
  trackingServiceUrl: 'https://tracking.api.gastro.digital'
};
applyRuntimeEnv(environment);
